import { IPair, ITradingKey, MainWallet, ChainNativeCurrency, SocialAccount, IStorageTradingKey, balancesCacheT, TelegramData, AppEnum, IGetWhiteList, DBAffiliate, PaginatedResult } from '../../interfaces';
import { Wallet } from '../../wallets/useActiveAccount';
import { saveSelectedPairOptions } from './persist.action';//@ts-ignore
import { KYCAuthenticationStatus } from '@libs/shared/db/enums/account/index';

export const actionTypes = {
  SAVE_WALLET_ADDRESS: 'SAVE_WALLET_ADDRESS',
  SAVE_MAIN_WALLET: 'SAVE_MAIN_WALLET',
  SAVE_KYC_STATUS: "SAVE_KYC_STATUS",
  SAVE_AFFILIATE_STATUS: "SAVE_AFFILIATE_STATUS",
  SAVE_AFFILIATE_DATA: "SAVE_AFFILIATE_DATA",
  SAVE_WALLET_BALANCE: "SAVE_WALLET_BALANCE",
  SET_CURRENCY: "SET_CURRENCY",
  SAVE_SELECTED_PAIR: 'SAVE_SELECTED_PAIR',
  UPDATE_SELECTED_WALLET: 'UPDATE_SELECTED_WALLET',
  UPDATE_MIN_BALANCE: 'UPDATE_MIN_BALANCE',
  SAVE_ACTIVE_EVM_CHAIN_ID: 'SAVE_ACTIVE_EVM_CHAIN_ID',
  SAVE_TRADING_KEYS: 'SAVE_TRADING_KEYS',
  SAVE_USER_KEY: "SAVE_USER_KEY",
  SAVE_USER_SOCIALS: "SAVE_USER_SOCIALS",
  SAVE_USER_POINTS: "SAVE_USER_POINTS",
  UPDATE_USER_SOCIALS: "UPDATE_USER_SOCIALS",
  UPDATE_USER_EVM_BALANCES: "UPDATE_USER_EVM_BALANCES",
  SAVE_WHITE_LIST: "SAVE_WHITE_LIST"
};

export const saveMainWallet = (data: Wallet | MainWallet) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_MAIN_WALLET,
    data: data,
  });
};

export const clearMainWallet = () => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_MAIN_WALLET,
    data: { address: '', chain: null },
  });
  dispatch({
    type: actionTypes.SAVE_KYC_STATUS,
    data: false,
  });
  dispatch({
    type: actionTypes.SAVE_AFFILIATE_STATUS,
    data: { isPageEnabled: false, isAffiliate: null }
  });
  dispatch({
    type: actionTypes.SAVE_AFFILIATE_DATA,
    data: null
  });
  dispatch({
    type: actionTypes.SAVE_TRADING_KEYS,
    data: [],
  });
  dispatch({
    type: actionTypes.SAVE_WHITE_LIST,
    data: [],
  });
  dispatch({
    type: actionTypes.SAVE_USER_KEY,
    data: null,
  });
  dispatch({
    type: actionTypes.SAVE_USER_SOCIALS,
    data: {
      userPoints: 0,
      userSocials: {
        email: "",
        twitter: null,
        discord: null,
        telegram: null
      }
    },
  });
};

export const saveSelectedPair = (data: IPair) => (dispatch, getState) => {
  const selectedPair = getState().user.selectedPair;

  if (!selectedPair || selectedPair?.id !== data.id) {
    dispatch(saveSelectedPairOptions(data));
    dispatch({
      type: actionTypes.SAVE_SELECTED_PAIR,
      data: data,
    });
  } else if (selectedPair.min_order_size !== data.min_order_size ||
    selectedPair.min_price_increment !== data.min_price_increment ||
    selectedPair.min_size_increment !== data.min_size_increment ||
    selectedPair.pairSettings.preSaleMode?.sellerAddress !== data.pairSettings.preSaleMode?.sellerAddress ||
    selectedPair.pairSettings.baseCoinIconLink !== data.pairSettings.baseCoinIconLink ||
    selectedPair.pairSettings.makerFee !== data.pairSettings.makerFee ||
    selectedPair.pairSettings.takerFee !== data.pairSettings.takerFee)
    {
      dispatch({
        type: actionTypes.SAVE_SELECTED_PAIR,
        data: data,
      });
  }
};

export const saveKYCStatus = (data: null | KYCAuthenticationStatus) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_KYC_STATUS,
    data: data === KYCAuthenticationStatus.APPROVED,
  });
};

export const saveAffiliateParams = (data: { enabled: boolean, isAffiliate: boolean }, isForAffiliates: boolean) => (dispatch) => {
  const isPageEnabled = isForAffiliates ? data.enabled && data.isAffiliate : true;

  dispatch({
    type: actionTypes.SAVE_AFFILIATE_STATUS,
    data: { isAffiliate: data.isAffiliate, isPageEnabled }
  });
};

export const saveIsAffiliate = ( data: boolean ) => (dispatch, getState) => {
  const isPageEnabled = getState().user.isAffiliatePageEnabled;
  dispatch({
    type: actionTypes.SAVE_AFFILIATE_STATUS,
    data: { isAffiliate: data, isPageEnabled }
  });
};

export const saveAffiliate = ( data: DBAffiliate ) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_AFFILIATE_DATA,
    data: data
  });
};


export const saveTradingKeys = (data: ITradingKey[]) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_TRADING_KEYS,
    data: [...data].sort((a, b) => Number(new Date(b.createdAt)) - Number(new Date(a.createdAt))),
  });
};

export const saveWhiteLists = (data: PaginatedResult<IGetWhiteList>) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_WHITE_LIST,
    data: data,
  });
};

export const saveUserKey = (data: IStorageTradingKey) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_USER_KEY,
    data: data,
  });
};

export const updateSelectedWallet = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_WALLET_ADDRESS,
    data: data,
  });
};

export const setCurrency = (data: ChainNativeCurrency) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_CURRENCY,
    data: data,
  });
};


export const updateSelectedWalletBalance = (data: string) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_WALLET_BALANCE,
    data: data,
  });
};

export const resetActiveWallet = () => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_WALLET_ADDRESS,
    data: "",
  });
  dispatch({
    type: actionTypes.SAVE_WALLET_BALANCE,
    data: "",
  });
  dispatch({
    type: actionTypes.SET_CURRENCY,
    data: null,
  });
  dispatch({
    type: actionTypes.UPDATE_MIN_BALANCE,
    data: 0,
  });
};

export const updateMinBalance = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_MIN_BALANCE,
    data: data,
  });
};

export const saveUserSocials = (data: SocialAccount) => (dispatch) => {
  const x = {
    userPoints: data.points,
    userSocials: {
      twitter: data.twitterAccount,
      discord: data.discordAccount,
      telegram: data.telegramAccount,
      email: data.email
    }
  }
  dispatch({
    type: actionTypes.SAVE_USER_SOCIALS,
    data: x,
  });
}

export const saveUserPoints = (data: number) => (dispatch, getState) => {
  const userPoints = getState().user.userPoints;
  dispatch({
    type: actionTypes.SAVE_USER_POINTS,
    data: Number(userPoints) + data,
  });
};

export const saveUserTelegram = (data: TelegramData) => (dispatch, getState) => {
  const userSocials = getState().user.userSocials;
  const telegramUser = {
    userName: data.username,
    telegramId: data.id
  }
  dispatch({
    type: actionTypes.UPDATE_USER_SOCIALS,
    data:  {
      ...userSocials,
      telegram: telegramUser,
    },
  });
};

export const clearUserSocial = (data: AppEnum) => (dispatch, getState) => {
  const userSocials = getState().user.userSocials;
  dispatch({
    type: actionTypes.UPDATE_USER_SOCIALS,
    data:  {
      ...userSocials,
      [data.toLowerCase()]: null,
    },
  });
};

export const updateUserEVMBalances = (data: balancesCacheT) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_USER_EVM_BALANCES,
    data: data,
  });
};
